export const InvalidLink: React.FC = () => {
  return (
    <div className="pageContainer">
      <div className="logoContainer">
        <img src={"./img/es-logo.svg"} width="110px" alt="Electric Shuffle" />
      </div>
      <div className="contentCard">
        <div className="errorContainer">
          <div className="errorTitleText">Invalid Link</div>
          <div className="errorText">Please use the touchscreen or talk to a host in venue</div>
          <div className="puckyBottomLine"></div>
          <img src={"./img/pucky.svg"} className="errorPucky" width="90px" alt="Electric Shuffle Pucky" />
        </div>
      </div>
    </div>
  );
};
